import { render, staticRenderFns } from "./SelectChildDialog.vue?vue&type=template&id=1950bf5d&scoped=true&"
import script from "./SelectChildDialog.vue?vue&type=script&lang=js&"
export * from "./SelectChildDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectChildDialog.vue?vue&type=style&index=0&id=1950bf5d&prod&scoped=true&lang=css&"
import style1 from "./SelectChildDialog.vue?vue&type=style&index=1&id=1950bf5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950bf5d",
  null
  
)

export default component.exports